<template>
    <header class="header">
        <div class="header__content">
            <SiteLogo />
            <button
                class="menu-icon"
                :class="{ 'menu-icon--active': isMenuOpen }"
                type="button"
                :aria-expanded="isMenuOpen"
                aria-controls="main-menu"
                aria-label="Menü öffnen/schließen"
                @click="toggleMenu"
            >
                <span class="navicon" aria-hidden="true"></span>
            </button>
            <nav>
                <ul id="main-menu" class="menu" :class="{ 'menu--open': isMenuOpen }">
                    <template v-if="!isUserAuthenticated">
                        <li>
                            <router-link to="/" @click="closeMenu">
                                Anmeldung
                            </router-link>
                        </li>
                    </template>
                    <template v-if="isUserAuthenticated">
                        <li v-if="isUserAuthenticated">
                            <a href="#" @click.prevent="handleLogout">
                                Abmeldung
                            </a>
                        </li>
                    </template> 
                       <li>
                            <router-link to="/kontakt" @click="closeMenu">
                                Kontakt
                            </router-link>
                        </li>
                </ul>
            </nav>
        </div>
    </header>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useUserStore } from '@/store/userStore'
import SiteLogo from './SiteLogo.vue'

const router = useRouter()
const userStore = useUserStore()

const isMenuOpen = ref(false)
const isUserAuthenticated = computed(() => userStore.isAuth)

const toggleMenu = () => {
    isMenuOpen.value = !isMenuOpen.value
}

const closeMenu = () => {
    isMenuOpen.value = false
}

const handleLogout = () => {
    closeMenu()
    userStore.logout()
    router.push('/')
}
</script>

<style lang="scss" scoped>
.header {
    background-color: var(--color-white);
    box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;
    margin-bottom: rem(25px);
    padding: rem(15px 0);

    &__logo {
        display: block;
        width: rem(90px);
        height: auto;
    }

    &__content {
        @extend %site-grid;
        position: relative;
    }

    ul {
        margin: 0;
        padding: 0;
        list-style: none;
        overflow: hidden;
        text-align: right;

        li {
            display: block;
            padding: rem(7.5px 10px 0 10px);

            &:first-child {
                margin-top: rem(250px);
            }

            a {
                background-color: transparent;
                color: var(--color-white);
                cursor: pointer;
                display: block;
                font-size: rem(30px);
                font-weight: 700;
                line-height: rem(35px);
                letter-spacing: rem(1.5px);
                text-decoration: none;
                text-transform: uppercase;
                transition: var(--default-transition);

                &:hover,
                &:focus {
                    color: var(--secondary-color);
                }
            }
        }
    }

    @include desktop {
        &__logo {
            display: block;
            width: rem(120px);
            height: auto;
        }

        ul li {
            display: inline-block;

            &:first-child {
                margin-top: 0;
            }

            a {
                color: var(--primary-color);
                padding: rem(15px 10px);
                font-size: rem(16px);
                font-weight: 500;
                line-height: rem(22px);
                letter-spacing: rem(1.5px);
            }
        }
    }
}

.menu {
    clear: both;
    max-height: 0;
    transition: var(--default-transition);

    &--open {
        max-height: none;
        min-height: 100vh;
        width: 100vw;
        position: fixed;
        top: 0;
        left: 0;
        background-color: var(--secondary-color);
        z-index: 10;
    }
}

.menu-icon {
    cursor: pointer;
    display: inline-block;
    padding: rem(20px 15px);
    position: fixed;
    right: rem(15px);
    top: rem(15px);
    user-select: none;
    background: transparent;
    border: none;
    z-index: 20;

    &--active .navicon {
        background: transparent;

        &::before {
            transform: rotate(-45deg);
            top: 0;
        }

        &::after {
            transform: rotate(45deg);
            top: 0;
        }
    }
}

.navicon {
    background: var(--primary-color);
    display: block;
    height: rem(2px);
    width: rem(25px);
    position: relative;
    transition: var(--default-transition);

    &::before,
    &::after {
        background: var(--primary-color);
        content: '';
        display: block;
        height: 100%;
        position: absolute;
        transition: var(--default-transition);
        width: 100%;
    }

    &::before {
        top: rem(5px);
    }

    &::after {
        top: rem(-5px);
    }
}

@include desktop {
    .menu {
        clear: none;
        float: right;
        max-height: none;
    }

    .menu-icon {
        display: none;
    }
}
</style>
